<template>
  <el-main>
    <!-- 類型選擇 -->
    <div>
      <el-radio-group v-model="nowCategoryId" size="medium">
        <el-radio-button v-for="item in categoryList" :key="item.name" :label="item.id">{{ item.category }}</el-radio-button>
      </el-radio-group>
    </div>
    <!-- 間隔 -->
    <br />
    <!-- data1 add btn -->
    <el-button v-if="categoryList.length > 0" type="primary" @click="data1.addForm1.dialogVisible = true">新增 + </el-button>
    <!-- 間隔 -->
    <br /><br />
    <!-- data1 table -->
    <el-table v-loading="loading" :data="data1.data.slice((currentPage - 1) * pagesize, currentPage * pagesize)" style="width: 100%">
      <el-table-column label="編號" width="60">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column label="日期" width="100">
        <template slot-scope="scope">
          {{ scope.row.date.substring(0, 10).replace(/-/g, '/') }}
        </template>
      </el-table-column>
      <el-table-column label="置頂" width="80">
        <template slot-scope="scope">
          <div v-if="scope.row.top" class="top-div">
            {{ scope.row.top ? '置頂' : '' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="訊息內容" width="">
        <template slot-scope="scope">
          {{ scope.row.content }}
        </template>
      </el-table-column>

      <el-table-column label="類型">
        <template slot-scope="scope">
          <el-link v-if="scope.row.contentType === 'Url'" :href="scope.row.url" target="_blank">連結</el-link>
          <span v-if="scope.row.contentType === 'Html'" :href="scope.row.url" target="_blank">文章</span>
          <span v-if="scope.row.contentType === 'Text'" :href="scope.row.url" target="_blank">純文字</span>
          <el-link v-if="scope.row.contentType === 'AttachmentFile'" :href="scope.row.url" target="_blank">檔案 ( {{ scope.row.attachmentFileName }} )</el-link>
        </template>
      </el-table-column>
      <el-table-column>
        <template slot-scope="scope">
          <el-button @click="data1UpdateForm1DialogOpen(scope.$index)">編輯</el-button>
          <el-button @click="data1Delete(scope.$index)">刪除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[1000000]" :page-size="pagesize" layout="total, sizes,prev, pager, next" :total="data1.data.length" prev-text="上一頁" next-text="下一頁"> </el-pagination>
    </div>

    <!-- data1 add1 dialog -->
    <el-dialog title="新增" :visible.sync="data1.addForm1.dialogVisible" width="90%" @closed="data1AddForm1DialogClosed()" :close-on-click-modal="false">
      <el-form :model="data1.addForm1.data" status-icon :rules="data1.addForm1.rules" ref="data1AddForm1" label-width="100px" class="demo-ruleForm" v-loading.lock="data1.addForm1.loading">
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.addForm1.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="data1AddForm1Submit()">送出</el-button>
          </div>
        </el-form-item>
        <el-form-item label="日期" prop="date">
          <el-date-picker v-model="data1.addForm1.data.date" type="date" value-format="yyyy/MM/dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="訊息內容" prop="content">
          <el-input type="textarea" v-model.trim="data1.addForm1.data.content" autocomplete="off" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="data1.addForm1.data.top">置頂</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-radio-group v-model="data1.addForm1.data.contentType">
            <el-radio label="Text">文字</el-radio>
            <el-radio label="Url">連結</el-radio>
            <el-radio label="AttachmentFile">附件</el-radio>
            <el-radio label="Html">文章</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          v-show="data1.addForm1.data.contentType === 'Url'"
          label="連結"
          prop="url"
          :rules="[
            {
              required: true,
              validator: data1AddForm1ValidUrl,
              trigger: 'blur',
            },
            // { required: true, message: '請輸入連結', trigger: 'blur' },
          ]"
        >
          <el-input type="text" v-model.trim="data1.addForm1.data.url" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          v-show="data1.addForm1.data.contentType === 'AttachmentFile'"
          label="附件"
          prop="attachmentFile"
          :rules="[
            {
              required: true,
              validator: data1AddForm1ValidAttachmentFile,
              trigger: 'blur',
            },
            // { required: true, message: '附件不得為空', trigger: 'blur' },
          ]"
        >
          <AttachmentFileUploader :fileQuantityLimit="1" :fileList.sync="data1.addForm1.data.attachmentFile"></AttachmentFileUploader>
        </el-form-item>

        <el-form-item v-show="data1.addForm1.data.contentType === 'Html'" label="文章" prop="html">
          <div>
            <el-button @click="multipleUpload = true"> <i class="el-icon-picture-outline"></i> 上傳多張照片</el-button>
          </div>
          <quill-editor style="background-color:white; margin:10px 0" v-model="data1.addForm1.data.html" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)"> </quill-editor>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert v-show="data1.addForm1.errorMessage.length > 0" type="error" :closable="false">{{ data1.addForm1.errorMessage }} </el-alert>
        </el-form-item>
                <el-form-item label="" prop="">
           <div class="formSubmitBtnBox">
            <el-button @click="data1.addForm1.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="data1AddForm1Submit()">送出</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- data1 update1 dialog -->
    <el-dialog title="編輯" :visible.sync="data1.updateForm1.dialogVisible" width="90%" @closed="data1UpdateForm1DialogClosed()" :close-on-click-modal="false">
      <el-form :model="data1.updateForm1.data" status-icon :rules="data1.updateForm1.rules" ref="data1UpdateForm1" label-width="100px" class="demo-ruleForm" v-loading.lock="data1.updateForm1.loading">
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button @click="data1.updateForm1.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="data1UpdateForm1Submit()">送出</el-button>
          </div>
        </el-form-item>
        <el-form-item label="日期" prop="date">
          <el-date-picker v-model="data1.updateForm1.data.date" type="date" value-format="yyyy/MM/dd"></el-date-picker>
        </el-form-item>
        <el-form-item label="訊息內容" prop="content">
          <el-input type="textarea" v-model.trim="data1.updateForm1.data.content" autocomplete="off" maxlength="100" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="data1.updateForm1.data.top">置頂</el-checkbox>
        </el-form-item>
        <el-form-item
          v-show="data1.updateForm1.data.contentType === 'Url'"
          label="連結"
          prop="url"
          :rules="[
            {
              required: true,
              validator: data1UpdateForm1ValidUrl,
              trigger: 'blur',
            },
            // { required: true, message: '請輸入連結', trigger: 'blur' },
          ]"
        >
          <el-input type="text" v-model.trim="data1.updateForm1.data.url" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          v-show="data1.updateForm1.data.contentType === 'AttachmentFile'"
          label="附件"
          prop="attachmentFile"
          :rules="[
            {
              required: true,
              validator: data1UpdateForm1ValidAttachmentFile,
              trigger: 'blur',
            },
            // { required: true, message: '附件不得為空', trigger: 'blur' },
          ]"
        >
          <AttachmentFileUploader :fileQuantityLimit="1" :fileList.sync="data1.updateForm1.data.attachmentFile"></AttachmentFileUploader>
        </el-form-item>
        <el-form-item v-show="data1.updateForm1.data.contentType === 'Html'" label="文章" prop="html">
                    <div>
            <el-button @click="multipleUpload2 = true"> <i class="el-icon-picture-outline"></i> 上傳多張照片</el-button>
          </div>
          <quill-editor style="background-color:white ;margin:10px 0" v-model="data1.updateForm1.data.html" ref="myQuillEditor" :options="editorOption" @blur="onEditorBlur($event)" @focus="onEditorFocus($event)" @ready="onEditorReady($event)"> </quill-editor>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-alert v-show="data1.updateForm1.errorMessage.length > 0" type="error" :closable="false">{{ data1.updateForm1.errorMessage }} </el-alert>
        </el-form-item>
        <el-form-item label="" prop="">
           <div class="formSubmitBtnBox">
            <el-button @click="data1.updateForm1.dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="data1AddForm1Submit()">送出</el-button>
          </div>
        </el-form-item>

      </el-form>
    </el-dialog>

    <!-- 多照片上傳 add dialog -->
    <el-dialog title="新增" :visible.sync="multipleUpload" width="30%" @closed="multipleUpload = false" :close-on-click-modal="false" >
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="照片" prop="picture">

              <el-upload class="upload-demo" action="" multiple :limit="20" accept=".jpg, .jpeg, .gif" :auto-upload="false" :file-list="multipleFiles" :on-change="handleFilesAdd">
      <el-button size="small" type="primary">選擇檔案</el-button>
    </el-upload>

        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button type="primary" @click="FinishUpload('add')">完成</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 多照片上傳 update dialog -->
    <el-dialog title="新增" :visible.sync="multipleUpload2" width="30%" @closed="multipleUpload = false" :close-on-click-modal="false" >
      <el-form label-width="100px" class="demo-ruleForm">
        <el-form-item label="照片" prop="picture">

              <el-upload class="upload-demo" action="" multiple :limit="20" accept=".jpg, .jpeg, .gif" :auto-upload="false" :file-list="multipleFiles" :on-change="handleFilesUpdate">
      <el-button size="small" type="primary">選擇檔案</el-button>
    </el-upload>

        </el-form-item>
        <el-form-item>
          <div class="formSubmitBtnBox">
            <el-button type="primary" @click="FinishUpload('update')">完成</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>

  </el-main>
</template>

<script>
import {
  C_NewsCategory_GetList, C_News_Add, C_News_GetList, C_News_Update, C_News_Delete, C_News_GetHtml,
} from '@/assets/js/api';
import AttachmentFileUploader from '@/components/AttachmentFileUploader.vue';
// import PictureUploader from '@/components/PictureUploader.vue';

export default {
  data() {
    return {
      multipleUpload: false,
      multipleUpload2: false,
      multipleFiles: [],
      fileList: [],
      loading: true,
      editorOption: {
        modules: {
          imageResize: {
            // 添加
            displayStyles: {
              // 添加
              backgroundColor: 'black',
              border: 'none',
              color: 'white',
            },
            modules: ['Resize', 'DisplaySize', 'Toolbar'], // 添加
          },
          imageCompress: {
            quality: 0.6, // default
            // maxWidth: 1000, // default
            // maxHeight: 1000, // default
            imageType: 'image/jpeg', // default
            debug: true, // default
            suppressErrorLogging: false, // default
          },
          toolbar: [
            ['bold', 'italic', 'underline', 'strike', 'image'],
            ['formula', 'clean'],
            ['blockquote', 'code-block'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }],
            // [{ font: fonts }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ align: [] }],
            [{ direction: 'rtl' }],
          ],
        },
        placeholder: '請輸入内容........',
      },
      currentPage: 1, // 默認顯示第一頁
      pagesize: 1000000, //    每頁顯示筆數
      nowCategoryId: 1,
      categoryList: [],
      data1: {
        data: [],
        addForm1: {
          dialogVisible: false,
          loading: false,
          formRef: 'data1AddForm1',
          errorMessage: '',
          data: {
            date: '',
            content: '',
            name: '',
            top: false,
            contentType: 'Text',
            attachmentFile: [],
            multipleFiles: [],
            url: '',
            html: '',
          },
          rules: {
            date: [{ required: true, message: '請輸入日期' }],
            content: [
              { required: true, message: '請輸入訊息內容' },
              { min: 1, max: 100, message: '訊息內容必須在100個字元內' },
            ],
          },
        },
        updateForm1: {
          updateId: 0,
          dialogVisible: false,
          loading: false,
          formRef: 'data1UpdateForm1',
          errorMessage: '',
          data: {
            date: '',
            content: '',
            name: '',
            top: false,
            contentType: 'Text',
            attachmentFile: [],
            multipleFiles: [],
            url: '',
            html: '<p> html </p>',
          },
          rules: {
            date: [{ required: true, message: '請輸入日期' }],
            content: [
              { required: true, message: '請輸入訊息內容' },
              { min: 1, max: 100, message: '訊息內容必須在300個字元內' },
            ],
          },
        },
      },
    };
  },
  components: {
    AttachmentFileUploader,
    // PictureUploader,
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  mounted() {
    C_NewsCategory_GetList()
      .then((res) => {
        this.categoryList = res.data.data;
        if (this.categoryList.length > 0) {
          this.nowCategoryId = this.categoryList[0].id;
        }
      })
      .catch((err) => {
        this.$notify.error({
          title: '錯誤',
          message: err.response.data.message,
        });
      });

    this.data1GetList();
  },
  watch: {
    $route() {},
    nowCategoryId() {
      this.loading = true;
      this.data1GetList();
    },
  },
  methods: {
    handleFilesAdd(file) {
      const fuck = file.raw;
      const reader = new FileReader();
      reader.onload = (event) => {
        this.compressBase64(event.target.result, 'add');
      };
      reader.readAsDataURL(fuck);
    },
    handleFilesUpdate(file) {
      const fuck = file.raw;
      const reader = new FileReader();
      reader.onload = (event) => {
        this.compressBase64(event.target.result, 'update');
      };
      reader.readAsDataURL(fuck);
    },

    compressBase64(path, action) {
      const image = new Image();
      image.src = path;
      image.onload = () => {
        // 生成canvas
        const w = image.width;
        const h = image.height;
        const quality = 0.6;
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        // 建立屬性節點
        const anw = document.createAttribute('width');
        anw.nodeValue = w;
        const anh = document.createAttribute('height');
        anh.nodeValue = h;
        canvas.setAttributeNode(anw);
        canvas.setAttributeNode(anh);
        ctx.drawImage(image, 0, 0, w, h);
        const base64 = canvas.toDataURL('image/jpeg', quality);
        // 串字串
        if (action === 'add') {
          const originalStr = this.data1.addForm1.data.html;
          this.data1.addForm1.data.html = `${originalStr}<img src="${base64}">`;
        } else {
          const originalStr = this.data1.updateForm1.data.html;
          this.data1.updateForm1.data.html = `${originalStr}<img src="${base64}">`;
        }
      };
    },
    FinishUpload(action) {
      if (action === 'add') {
        this.multipleUpload = false;
      } else {
        this.multipleUpload2 = false;
      }
      this.multipleFiles = [];
    },
    handleSizeChange(size) {
      this.pagesize = size;
      /* console.log(this.pagesize) */
    },
    // 点击第几页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      /* console.log(this.currentPage) */
    },
    // 驗證，特殊處理在form內使用v-if造成的bug，改使用v-show，並使用下列的判斷。
    // eslint-disable-next-line no-unused-vars
    data1AddForm1ValidUrl(rule, value, callback) {
      if (this.data1.addForm1.data.contentType === 'Url') {
        if (value === '') {
          callback(new Error('請輸入連結'));
        }
      }
      callback();
    },
    // eslint-disable-next-line no-unused-vars
    data1AddForm1ValidAttachmentFile(rule, value, callback) {
      if (this.data1.addForm1.data.contentType === 'AttachmentFile') {
        if (value.length === 0) {
          callback(new Error('附件不得為空'));
        }
      }
      callback();
    },
    // eslint-disable-next-line no-unused-vars
    data1UpdateForm1ValidUrl(rule, value, callback) {
      if (this.data1.updateForm1.data.contentType === 'Url') {
        if (value === '') {
          callback(new Error('請輸入連結'));
        }
      }
      callback();
    },
    // eslint-disable-next-line no-unused-vars
    data1UpdateForm1ValidAttachmentFile(rule, value, callback) {
      if (this.data1.updateForm1.data.contentType === 'AttachmentFile') {
        if (value.length === 0) {
          callback(new Error('附件不得為空'));
        }
      }
      callback();
    },
    // data1 get list
    data1GetList() {
      C_News_GetList(this.nowCategoryId)
        .then((res) => {
          this.loading = false;
          console.log(res.data.data);
          this.data1.data = res.data.data;
          for (let i = 0; i < res.data.data.length; i += 1) {
            this.data1.data[i].date = res.data.data[i].date.substring(0, 10).replace(/-/g, '/');
          }
        })
        .catch((err) => {
          this.$notify.error({
            title: '錯誤',
            message: err.response.data.message,
          });
        });
    },
    // data1 add1
    data1AddForm1DialogClosed() {
      this.data1.addForm1.loading = false;
      this.$refs[this.data1.addForm1.formRef].resetFields();
      this.data1.addForm1.errorMessage = '';
    },
    data1AddForm1Submit() {
      this.$refs[this.data1.addForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.addForm1.loading = true;
          this.data1.addForm1.errorMessage = '';
          const fd = new FormData();
          fd.append('contentType', this.data1.addForm1.data.contentType);
          fd.append('categoryId', this.nowCategoryId);
          fd.append('content', this.data1.addForm1.data.content);
          fd.append('date', this.data1.addForm1.data.date);
          fd.append('top', this.data1.addForm1.data.top);
          if (this.data1.addForm1.data.contentType === 'AttachmentFile') {
            fd.append('attachmentFormFile', this.data1.addForm1.data.attachmentFile[0].raw);
          } else if (this.data1.addForm1.data.contentType === 'Url') {
            fd.append('url', this.data1.addForm1.data.url);
          } else if (this.data1.addForm1.data.contentType === 'Html') {
            fd.append('url', this.data1.addForm1.data.html);
          }

          C_News_Add(fd)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '新增成功',
                type: 'success',
              });
              this.data1.addForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.addForm1.errorMessage = err.response.data.message;
              this.data1.addForm1.loading = false;
            });
        }
      });
    },
    // data1 update1
    data1UpdateForm1DialogOpen(index) {
      const thisData = this.data1.data[index];
      this.data1.updateForm1.updateId = this.data1.data[index].id;
      this.data1.updateForm1.dialogVisible = true;

      this.data1.updateForm1.data.contentType = thisData.contentType;
      this.data1.updateForm1.data.date = thisData.date;
      this.data1.updateForm1.data.content = thisData.content;
      this.data1.updateForm1.data.top = thisData.top;
      if (this.data1.updateForm1.data.contentType === 'AttachmentFile') {
        this.data1.updateForm1.data.attachmentFile = [
          {
            name: thisData.attachmentFileName,
            url: thisData.url,
            originalFile: true,
          },
        ];
      } else if (this.data1.updateForm1.data.contentType === 'Url') {
        this.data1.updateForm1.data.url = thisData.url;
      } else if (this.data1.updateForm1.data.contentType === 'Html') {
        // this.data1.updateForm1.data.html = thisData.html;
        this.data1.updateForm1.data.html = '<h1>訊息加載中… 請稍後。</h1>';
        C_News_GetHtml(this.data1.updateForm1.updateId)
          .then((res) => {
            this.data1.updateForm1.data.html = res.data.message;
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    data1UpdateForm1DialogClosed() {
      this.data1.updateForm1.loading = false;
      this.$refs[this.data1.updateForm1.formRef].resetFields();
      this.data1.updateForm1.updateId = 0;
      this.data1.updateForm1.errorMessage = '';
    },
    data1UpdateForm1Submit() {
      this.$refs[this.data1.updateForm1.formRef].validate((valid) => {
        if (valid) {
          this.data1.updateForm1.errorMessage = '';
          this.data1.updateForm1.loading = true;
          const fd = new FormData();
          fd.append('content', this.data1.updateForm1.data.content);
          fd.append('date', this.data1.updateForm1.data.date);
          fd.append('top', this.data1.updateForm1.data.top);
          if (this.data1.updateForm1.data.contentType === 'AttachmentFile') {
            const checkPicture = this.data1.updateForm1.data.attachmentFile[0].originalFile !== true;
            if (checkPicture) {
              fd.append('attachmentFormFile', this.data1.updateForm1.data.attachmentFile[0].raw);
            }
          } else if (this.data1.updateForm1.data.contentType === 'Url') {
            fd.append('url', this.data1.updateForm1.data.url);
          } else if (this.data1.updateForm1.data.contentType === 'Html') {
            fd.append('url', this.data1.updateForm1.data.html);
          }
          C_News_Update(this.data1.updateForm1.updateId, fd)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '修改成功',
                type: 'success',
              });
              this.data1.updateForm1.dialogVisible = false;
              this.data1GetList();
            })
            .catch((err) => {
              this.data1.updateForm1.loading = false;
              this.data1.updateForm1.errorMessage = err.response.data.message;
            });
        }
      });
    },
    // data1 delete
    data1Delete(index) {
      this.$confirm('確定刪除?', '確認', {
        confirmButtonText: '確定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          C_News_Delete(this.data1.data[index].id)
            .then(() => {
              this.$notify({
                title: '成功',
                message: '刪除成功',
                type: 'success',
              });
              this.data1GetList();
            })
            .catch((err) => {
              this.$message({
                message: err.response.data.message,
                type: 'warning',
              });
            });
        })
        .catch(() => {});
    },
    goAlbum(newsId) {
      this.$router.push({ name: '/group/news/album', params: { id: newsId } });
    },
  },
};
</script>

<style scoped>
.top-div {
  align-items: center;
  padding: 5px 8px;
  width: 48px;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  box-sizing: border-box;
  border-radius: 4px;

  color: #409eff;
}
.pagination {
  margin: 10px 0 0 0;
  text-align: center;
}
.ql-editor {
  height: 250px;
}
</style>
